import React from 'react'
import { Link } from 'react-router-dom'

const Subscriptions = (props) => {
  const { url, subscriptions } = props
  return (
    <section className="webhook-details">
      <div class="pane">
        <div className="pane__header d-f ai-c jc-sb">
          <h3>{url}</h3>

          <Link
            className="tds-btn tds-btn--outline-neutral"
            to={{
              pathname: '/subscriptions/edit',
              state: {
                url: url,
                active: subscriptions.map((s) => {
                  return s.attributes.name
                }),
              },
            }}
          >
            Edit
          </Link>
        </div>

        <div className="pane__body">
          <ul className="webhook-details__subscriptions">
            {subscriptions.map((sub) => {
              return (
                <li key={sub.id}>
                  <span
                    className={`webhook-details__subscription-status webhook-details__subscription-status--${
                      sub.attributes.active ? 'active' : 'inactive'
                    }`}
                  />

                  <Link to={`/subscriptions/${sub.id}`}>
                    {sub.attributes.name}
                  </Link>
                </li>
              )
            })}
          </ul>
        </div>
      </div>
    </section>
  )
}

export default Subscriptions
